<mat-toolbar class="toolbar-subtitle">
  <mat-toolbar-row>Booking information (Wellpass only)</mat-toolbar-row>
</mat-toolbar>

@if (!classBookingEnabled) {
  <mat-form-field class="schedule-field">
    <mat-label>Link to the class schedule (optional)</mat-label>
    <input
      matInput
      placeholder="Link to the class schedule (optional)"
      #linkInput="ngModel"
      [(ngModel)]="scheduleLink"
      name="scheduleLink"
      id="scheduleLink"
      [disabled]="!editMode"
      gymfinderUrlValidator />
    @if (linkInput.errors?.['invalidUrl']) {
      <mat-error> Invalid URL</mat-error>
    }
  </mat-form-field>
}

<mat-card class="booking-subsection">
  <mat-card-content class="flex-display">
    <div class="left flex-column">
      <mat-label>Is booking required for members?</mat-label>
      @if (classBookingEnabled) {
        <mat-radio-group
          [value]="'WELLPASS_APP'"
          class="requirement-type-group"
          disabled>
          <mat-radio-button class="radio-label" [value]="'WELLPASS_APP'"
            >Book via Wellpass app
          </mat-radio-button>
        </mat-radio-group>
      }

      @if (!classBookingEnabled) {
        <mat-radio-group
          aria-labelledby="Select an option"
          class="requirement-type-group flex-column"
          [(ngModel)]="requirementType">
          @for (
            requirementType of requirementTypes; track requirementTrackByFn($index,
            requirementType)) {
            <mat-radio-button
              [value]="requirementType.value"
              class="radio-label"
              >{{ requirementType.label }}
            </mat-radio-button>
          }
        </mat-radio-group>
      }

      <div class="clear-booking-info-btn-wrapper">
        @if (isClearExternalBookingVisible) {
          <button
            mat-button
            (click)="clearExternalBookingInfo()"
            id="clearExternalBookingBtn">
            <mat-icon>clear</mat-icon>
            Reset booking selection
          </button>
        }
      </div>
    </div>

    @if (hasExternalBookingChannels) {
      <div class="flex-column flex-50">
        <mat-form-field class="booking-field">
          <mat-label>Booking email</mat-label>
          <input
            matInput
            placeholder="Booking email"
            [(ngModel)]="channelEmail"
            name="channelEmail"
            id="channelEmail"
            [disabled]="!editMode" />
        </mat-form-field>
        <mat-form-field class="booking-field">
          <mat-label>Booking phone number</mat-label>
          <input
            matInput
            placeholder="Booking phone number"
            [(ngModel)]="channelPhone"
            name="channelPhone"
            id="channelPhone"
            [disabled]="!editMode" />
        </mat-form-field>
        <mat-form-field class="booking-field">
          <mat-label>Booking link</mat-label>
          <input
            matInput
            placeholder="Booking link"
            [(ngModel)]="channelLink"
            name="channelLink"
            id="channelLink"
            [disabled]="!editMode" />
        </mat-form-field>
      </div>
    }
  </mat-card-content>
</mat-card>
